import { thousandSeparator } from "../helper/utils";
import { Product, ProductPricingModel } from "../types"

export const usePricingModel = () => {

    const renderProductPricingModelJSON = (product: Product): ProductPricingModel => {

        const { applyDiscount, price, discountPrice, currency, discountType } = product;
        
        if (applyDiscount && discountType === 'PERCENTAGE') {
            const discountOff = (((price - discountPrice) / price) * 100)
            return {
                price: discountPrice,    
                priceString: currency + "" + thousandSeparator(discountPrice.toFixed(2)),
                strikeThroughPrice: price,
                strikeThroughPriceString: currency + "" + thousandSeparator(price.toFixed(2)),
                discountOff: discountOff + "%",
            }
        }
        else if (product.applyDiscount && product.discountType === 'FIXED') {
            const discountedPrice = (price - discountPrice)
            return {
                price: discountedPrice,    
                priceString: currency + "" + thousandSeparator(discountedPrice.toFixed(2)),
                strikeThroughPrice: price,
                strikeThroughPriceString: currency + "" + thousandSeparator(price.toFixed(2)),
                discountOff: currency + "" + thousandSeparator(discountPrice.toFixed(0)),
            }
        }

        return {
            price: price,    
            priceString: currency + "" + thousandSeparator(price.toFixed(2)),
            strikeThroughPrice: undefined,
            strikeThroughPriceString: undefined,
            discountOff: undefined,
        }
    }
    
    
    const renderProductPricingModelJSX = (product: Product): React.ReactNode => {

        const { applyDiscount, discountType } = product;
        
        if (applyDiscount && discountType === 'PERCENTAGE') {
            return <RenderProductPercentPricing { ...product }  />
        }
        else if (applyDiscount && discountType === 'FIXED') {
            return <RenderProductFixedPricing { ...product } />
        }

        return (
            <span style={{
                color: '#000',
                fontWeight: 'bolder',
                marginRight: '5px'
            }}>{ product.priceString }</span> 
        )
    }


    return {
        renderProductPricingModelJSX,
        renderProductPricingModelJSON
    }
}


const RenderProductPercentPricing = (props: Product) => {

    const { priceString, strikeThroughPriceString, discountOff } = props;

    console.log("props = ", props);

    return (
        <>
            <span style={{
                color: '#000',
                fontWeight: 'bolder',
                marginRight: '5px'
            }}>{ priceString }</span> 

            {strikeThroughPriceString && (<span className="text-default" style={{
                textDecoration: 'line-through',
                marginRight: '5px',
                fontSize: '1rem'
            }}>{  strikeThroughPriceString }</span>)}

            {discountOff && (<span>
                <small className="text-danger" style={{fontSize: '.8rem'}}>
                    { discountOff } Off
                </small>
            </span>)}
        </>
    )
}


const RenderProductFixedPricing = (props: Product) => {

    const { priceString, strikeThroughPriceString, discountOff } = props;
    
    return (
        <>
            <span style={{
                color: '#000',
                fontWeight: 'bolder',
                marginRight: '5px'
            }}>{ priceString }</span> 

            {strikeThroughPriceString && (<span className="text-default" style={{
                textDecoration: 'line-through',
                marginRight: '5px',
                fontSize: '1rem'
            }}>{ strikeThroughPriceString }</span>)}

            {discountOff && (<span>
                <small className="text-danger" style={{fontSize: '.8rem'}}>
                    { discountOff } Off
                </small>
            </span>)}
        </>
    )
}